import { Thumbmark } from "@thumbmarkjs/thumbmarkjs"

const INCLUDE_KEYS = [
  "audio",
  "canvas",
  "fonts",
  "hardware",
  "locales",
  "math",
  "permissions",
  "plugins",
  "screen",
  "system",
  "webgl"
]
const EXCLUDE_KEYS = ["screen.resolution"]

export const getFingerPrint = async () => {
  try {
    const t = new Thumbmark({
      stabilize: ["private", "iframe"],
      include: INCLUDE_KEYS,
      exclude: EXCLUDE_KEYS
    })

    const tm = await t.get()

    const { thumbmark, components, version } = tm

    const reponse = {
      fingerprint: thumbmark,
      fingerprintCanvas: components?.canvas?.commonPixelsHash ?? null,
      fingerprintWebGL: components?.webgl?.commonPixelsHash ?? null,
      audio: components.audio,
      fonts: components.fonts,
      hardware: components.hardware,
      locales: components.locales,
      math: components.math,
      permissions: components.permissions,
      plugins: components.plugins,
      screen: components.screen,
      system: components.system,
      thumbmarkjsVersion: version
    }

    return reponse
  } catch (error) {
    console.error("initFingerPrint error", error)
  }

  return null
}

export default getFingerPrint
